<template>
  <el-card
    class="background"
    v-loading="loading"
    element-loading-text="数据加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(255, 255, 255, 0.7)"
  >
    <div class="announcement-overview">
      <SiruiSearch
        ref="searchRef"
        :query="queryData"
        :columns="topColumns"
        :isQueryPanel="true"
        @resetBtnClick="resetBtnClick"
        @searchBtnClick="searchTrigger"
        @changeMethod="changeMethod"
      ></SiruiSearch>
      <div class="result-table">
        <sirui-table
          ref="siruiTable"
          :buttonList="menuButtonList"
          @chooseClick="chooseClick"
          @handleSelectionChange="handleSelectionChange"
          :cellStyle="cellStyle"
          :cellClick="cellClick"
          :loading="loading"
          :data="tableData"
          :paging="true"
          :setting="false"
          :customVisible="true"
          :columns="tableColumns"
          @handleSizeChange="() => getTableData()"
          @handleCurrentChange="() => getTableData()"
        >
          <vxe-table-column type="checkbox" width="50" fixed="left"></vxe-table-column>
          <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column>
          <vxe-table-column
            align="center"
            v-for="(item, index) in tableColumns"
            :key="index"
            :fixed="item.fixed"
            :sortable="item.sortable"
            :field="item.field"
            :title="item.title ? $t(item.title) : null"
            :visible="item.visible"
            :type="item.type"
            :width="item.width"
          >
            <template slot-scope="scope">
              <template v-if="item.field == 'type'">
                {{ getTypeName(scope.row[item.field]) }}</template
              >
              <template v-else>{{ scope.row[item.field] }}</template>
            </template>
          </vxe-table-column>
        </sirui-table>
        <AnnouncementDeleteDialog
          ref="deleteDialogRef"
          @handleSure="handleDelete"
          @handleClose="handleClose"
          :deleteNumber="deleteNumber"
        ></AnnouncementDeleteDialog>
      </div>
    </div>
  </el-card>
</template>

<script>
  import { searchColumns } from './columns/searchColumns';
  import { defaultTableColumns } from './index.js';
  import AnnouncementDeleteDialog from './components/announcementDeleteDialog';
  import AnnouncementServiceMixin from '@/pages/property/announcement/mixins/announcementServiceMixin';
  export default {
    mixins: [AnnouncementServiceMixin],
    data() {
      return {
        loading: false,
        tableColumns: [], //表格的表头
        queryData: {
          // companyName: '',
          companyCode: '',
          departmentCode: '',
          // departmentName: '',
          title: '',
          type: '',
          createPersonName: '',
          noticeSearchDateStart: '',
          noticeSearchDateEnd: '',
        },
        menuButtonList: [], // 表格功能按钮
        tableData: [], // 表格数据:
        selectedItems: [], //选中行的数据
      };
    },
    computed: {
      topColumns() {
        return searchColumns(this);
      },
      deleteNumber() {
        return this.selectedItems.length;
      },
    },
    mounted() {
      this.$refs.siruiTable.setPageNum(1);
      this.$refs.siruiTable.setPageSize(10);
      this.queryData.companyCode = this.userInfo.companyCode;
      this.getTableData();
      this.getButtonList();
      this.getDepartmentList(this.userInfo.companyCode);
      // this.queryData.companyName = this.userInfo.companyName;
      // this.queryData.departmentName = this.userInfo.departmentName;
    },
    methods: {
      //列表标题的样式
      cellStyle({ column }) {
        if (column.property == 'title') {
          // console.log('cellStyle', row, rowIndex, column, columnIndex);
          return {
            color: '#009fcc',
            cursor: 'pointer',
          };
        }
        // console.log(column, 'column');
      },
      // 搜索
      searchTrigger() {
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.clearCheckboxReserve();
        this.getTableData();
      },
      //重置
      resetBtnClick() {
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.setPageSize(10);
        this.$refs.siruiTable.clearCheckboxReserve();
        this.selectedItems = [];
        // this.queryData = {};
        // this.queryData.companyName = this.userInfo.companyName;
        this.queryData = {
          companyCode: this.userInfo.companyCode,
          companyName: null,
          departmentCode: null,
          departmentName: null,
        };
        this.getTableData();
      },
      //checkbox选中触发事件
      handleSelectionChange(row) {
        this.selectedItems = row;
        console.log(row, 'selectedItems');
      },
      //点击标题跳转到详情
      cellClick(val) {
        if (val.column?.property == 'title') {
          // this.toDepositDetail(val.row.id);
          const path = {
            path: '/property/announcementDetail',
            name: 'announcementDetail',
            meta: {
              keepAlive: true,
              title: '通知公告详情',
            },
            query: {
              id: val.row.id,
              pageMode: 1,
            },
          };
          this.$router.push(path);
        }
      },
      // 表格上面的按钮
      chooseClick(type) {
        try {
          this[type]();
        } catch (error) {
          this.$message({
            showClose: true,
            type: 'error',
            message: '该方法未提供',
          });
        }
      },
      // 创建
      create() {
        let path = {
          path: '/property/announcementCreate',
          name: 'announcementCreate',
          meta: {
            keepAlive: false,
            title: '通知公告新增',
          },
          query: {
            pageMode: 0,
          },
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      // 修改
      edit() {
        let justOne = this.selectedItems.length == 1;
        let id = justOne ? this.selectedItems[0].id : '';
        console.log(id, 'id');
        if (justOne) {
          let path = {
            path: '/property/announcementEdit',
            name: 'announcementEdit',
            meta: {
              keepAlive: false,
              title: '通知公告编辑',
            },
            query: {
              pageMode: 2,
              id: id,
            },
          };
          this.$store.dispatch('tagsView/addTabView', path).then(() => {
            this.$nextTick(() => {
              this.$router.push(path);
            });
          });
        } else {
          this.$message({ showClose: true, type: 'error', message: '请选择一条数据!' });
        }
      },
      // 点击删除，弹出弹窗
      delete() {
        let flag = this.selectedItems.length > 0;
        if (flag) {
          this.$refs.deleteDialogRef.openDialog();
        } else {
          this.$message({ showClose: true, type: 'error', message: '请先选择数据!' });
        }
      },
      // 删除确认
      async handleDelete() {
        let ids = this.selectedItems.map((item) => {
          return item.id;
        });
        console.log(ids, 'ids');
        await this.deleteData(ids);
        this.getTableData();
      },
      //获取当前列数据
      getColumnInfo() {
        this.getColumnList(defaultTableColumns).then(() => {
          this.tableColumns = defaultTableColumns;
        });
      },
      // 删除弹窗取消，关闭
      handleClose() {
        this.$refs.siruiTable.clearCheckboxReserve();
      },
      // 获取表格数据
      async getTableData() {
        let params = {};
        params = this.queryData;
        console.log(params.noticeSearchDateEnd, 'length');
        if (params.noticeSearchDateEnd != null && params.noticeSearchDateStart != null) {
          if (params.noticeSearchDateEnd.length == 10) {
            let noticeSearchDateEnd = params.noticeSearchDateEnd + ' 24:00:00';
            params.noticeSearchDateEnd = noticeSearchDateEnd;
          }
          if (params.noticeSearchDateStart.length == 10) {
            let noticeSearchDateStart = params.noticeSearchDateStart + ' 00:00:00';
            params.noticeSearchDateStart = noticeSearchDateStart;
          }
        }
        params.pageNum = this.$refs.siruiTable.page.pageNum;
        params.pageSize = this.$refs.siruiTable.page.pageSize;
        params.adminFlag = this.userInfo.adminFlag;
        // params.companyCode = this.userInfo.companyCode;
        // params.departmentCode = this.userInfo.departmentCode;
        params = {
          ...params,
          pageNum: this.$refs.siruiTable.page.pageNum,
          // companyCode: this.userInfo.companyCode,
          pageSize: this.$refs.siruiTable.page.pageSize,
          adminFlag: this.userInfo.adminFlag,
          // companyName: this.userInfo.companyName,
          // departmentCode: this.userInfo.departmentCode,
          // departmentName: this.userInfo.departmentName,
        };
        console.log(this.filterEmpty(params));
        this.loading = true;
        var res = await this.getData(this.filterEmpty(params));
        this.loading = false;
        if (res) {
          this.tableData = res.records || [];
          //清空选择fixme
          this.$refs.siruiTable.setPageTotal(res.total);
          // this.$refs.siruiTable.setPageTotal(10);
          // this.$refs.siruiTable.setPageSize(res.size);
          this.selectedItems = [];
        }
      },
      //获取菜单按钮
      getButtonList() {
        this.getButtons().then((e) => {
          this.menuButtonList = e;
          // console.log('menuButtons', this.menuButtonList);
          this.getColumnInfo();
        });
      },
    },
    components: { AnnouncementDeleteDialog },
  };
</script>

<style></style>
